export const invoiceStatuses = [
  { value: 1, label: '审核中', tag: 'warning' },
  { value: 2, label: '已开具', tag: 'success' },
  { value: 3, label: '已拒绝', tag: 'danger' },
  { value: 4, label: '已红冲', tag: 'info' },
  { value: 5, label: '开具中', tag: 'warning' },
  { value: 6, label: '已撤回', tag: 'info' }
]

export const invoiceSubjects = [
  { value: 0, label: '电费' }, { value: 1, label: '电表月租' },
  { value: 2, label: '水费' }, { value: 3, label: '房租' },
  { value: 4, label: '服务费' }, { value: 5, label: '技术服务费' },
  { value: 6, label: '充电电费' }, { value: 7, label: '充电服务费' }
]

export const hasValue = value => value !== null && value !== undefined && value !== ''
export const enumNumber = value => hasValue(value) ? Number(value) : null
export const labelOf = (items, value) => {
  const item = items.find(item => String(item.value) === String(value))
  return item ? item.label : '-'
}
export const statusTag = value => (invoiceStatuses.find(item => item.value === enumNumber(value)) || {}).tag || 'info'
export const statusLabel = value => labelOf(invoiceStatuses, value)
export const subjectLabel = value => labelOf(invoiceSubjects, value)
export const invoiceTypeLabel = value => ({ '02': '增值税普通发票', '028': '增值税专用发票' }[value] || '-')
export const billTypeLabel = value => hasValue(value) ? ({ 0: '日结开票', 1: '充值开票', 2: '日结充值开票' }[value] || '-') : '-'
export const titleTypeLabel = value => enumNumber(value) === 1 ? '个人' : '企业'
export const recordTypeLabel = value => hasValue(value) ? ({ 0: '正常发票', 1: '红冲发票' }[value] || '-') : '-'
export const settleWayLabel = value => hasValue(value) ? ({ 0: '普通结算', 1: '手动扣款', 2: '系统补单', 3: '浮动电价', 4: '分摊结算', 5: '设备扣款', 10: '租户充值' }[value] || '-') : '-'
export function money (value) {
  return hasValue(value) && Number.isFinite(Number(value)) ? `¥${Number(value).toFixed(2)}` : '-'
}
export function displayTime (value) {
  return value ? String(value).replace('T', ' ') : '-'
}
export function normalizeInvoice (row) {
  return { ...row, status: enumNumber(row.status), billType: enumNumber(row.billType), suject: enumNumber(row.suject), provider: enumNumber(row.provider) }
}
export function canAudit (row, managerId, expectedStatus = 1) {
  return !!(hasValue(managerId) && hasValue(row.id) && String(row.managerId) === String(managerId) &&
    enumNumber(row.status) === expectedStatus && [0, 1, 2].includes(enumNumber(row.billType)))
}
export function buildInvoiceQuery (managerId, filters, page) {
  if (!hasValue(managerId)) throw new Error('请先选择管理方')
  const data = { managerId, billKind: 0, page: { current: page.current, size: page.size, orders: [{ column: 'createTime', asc: false }] } }
  ;['tenantId', 'tenantName', 'fphm', 'status', 'suject', 'fplxdm', 'enterpriseName', 'type'].forEach(key => {
    const value = filters[key]
    if (hasValue(value)) data[key] = typeof value === 'string' ? value.trim() : value
  })
  if (filters.timeRange && filters.timeRange.length === 2) {
    data.startDate = filters.timeRange[0]
    data.endDate = filters.timeRange[1]
  }
  return data
}
export function buildAuditRequest (row, managerId, decision, reason, isSentMail) {
  if (!canAudit(row, managerId)) throw new Error('该申请不属于当前管理方、状态已变更或开票方式不支持，请刷新后重试')
  if (![1, 3].includes(decision)) throw new Error('请选择审核意见')
  const refuseReason = decision === 3 ? String(reason || '').trim() : ''
  if (decision === 3 && !refuseReason) throw new Error('请填写拒绝原因')
  const params = { invoiceManageId: row.id, status: decision, refuseReason }
  const method = enumNumber(row.billType) === 1 ? 'auditRecharge' : 'auditDaily'
  return { method, params: { ...params, isSentMail: decision === 1 && !!isSentMail } }
}
export function billDetailsQuery (row) {
  let ids = row.settleTenantIds
  if (typeof ids === 'string') {
    try { ids = JSON.parse(ids) } catch (e) { throw new Error('关联账单编号格式异常') }
  }
  if (!Array.isArray(ids) || !ids.length) return null
  if (!hasValue(row.billType) || !hasValue(row.suject)) throw new Error('缺少关联账单查询参数')
  return { billType: enumNumber(row.billType), suject: enumNumber(row.suject), settleTenantIds: ids }
}
export function safeFileUrl (value) {
  if (typeof value !== 'string' || !/^https?:\/\//i.test(value)) return ''
  try {
    const url = new URL(value)
    return url.username || url.password ? '' : url.href
  } catch (e) { return '' }
}
export function invoiceFiles (data) {
  return ['pdf', 'ofd', 'xml'].map(type => ({ type: type.toUpperCase(), url: safeFileUrl(data && data[`${type}Url`]) })).filter(item => item.url)
}
export function availableQuota (data, suject) {
  const keys = { 0: ['invoiceAmount', 'elecOverdraw'], 2: ['waterInvoiceAmt', 'waterOverdraw'], 3: ['houseInvoiceAmt', 'houseOverdraw'], 4: ['serviceInvoiceAmt', 'serviceOverdraw'] }[suject]
  if (!keys || !data || !keys.every(key => hasValue(data[key]) && Number.isFinite(Number(data[key])))) return null
  return Number(data[keys[0]]) + Number(data[keys[1]])
}
